import { render, staticRenderFns } from "./PropertiesSelector.vue?vue&type=template&id=838f3f20&scoped=true&"
import script from "./PropertiesSelector.vue?vue&type=script&lang=js&"
export * from "./PropertiesSelector.vue?vue&type=script&lang=js&"
import style0 from "./PropertiesSelector.vue?vue&type=style&index=0&id=838f3f20&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "838f3f20",
  null
  
)

export default component.exports